import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageContentComponent } from './components/page-content/page-content.component';
import { PageContentHeaderComponent } from './components/page-content-header/page-content-header.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ContentLoader } from './components/content-loader/content-loader.component';

@NgModule({
  declarations: [
    PageContentComponent,
    PageContentHeaderComponent,
    BreadcrumbComponent,
    ContentLoader,
  ],
  imports: [CommonModule, NgxSpinnerModule, TranslateModule.forChild()],
  exports: [
    PageContentComponent,
    PageContentHeaderComponent,
    BreadcrumbComponent,
    ContentLoader,
  ],
})
export class PageContentModule {}
